import { createSelector } from 'reselect';

export const getInvestmentCalculators = state => state.investmentCalculators;
export const getInvestmentCalculator = createSelector(
    getInvestmentCalculators,
    (investmentCalculators) => investmentCalculators.investmentCalculator
);
